import { useEffect } from 'react';

const isOrContains = (target, el, extraSelector) => !el ||
    el.contains(target) ||
    (extraSelector && target.closest(extraSelector))

// for best performance, wrap the callback in useCallback with a proper
// dependency array for any props used in the callback, if any
/**
 * Reusable hook that triggers click outside of ref
 * @param {*} ref Incoming DOM element
 * @param {fn} callback Function that gets called on click
 * @param {string} extraSelector String selector for elements to also ignore
 */
export const useOnOutsideClick = (ref, callback, extraSelector) => {
    useEffect(
        () => {
            const listener = event => {
                const { target } = event
                if (!isOrContains(target, ref.current, extraSelector)) {
                    callback(event)
                }
            }
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
            return () => {
                document.removeEventListener("mousedown", listener);
                document.removeEventListener("touchstart", listener);
            }
        },
        [ref, callback]
    )
}


export default useOnOutsideClick;